import ACTIONS from '@/store/storeActions';

const mutations = {
  /**
   * @param state - state
   * @param {Object} payload - payload
   */
  [ACTIONS.SET_USER]: (state, payload) => {
    state.user = payload;
  },
  /**
   * @param state
   * @param {String} type (timeTable | user)
   * @param loadingState
   */
  [ACTIONS.SET_USER_LOADINGSTATE]: (state, payload) => {
    state.loadingState = payload
  }
}

export default mutations
